import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import * as d3 from 'd3';
import { ConfirmationDialogComponent } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { SocketService } from 'src/app/services/socket/socket.service';
import { environment } from 'src/environments/environment';
import { ConfirmdialogComponent } from '../confirmdialog/confirmdialog.component';
import { MessageService } from 'src/app/services/message/message.service';
import { SubjectMapComponent } from '../subject-map/subject-map.component';
import * as moment from 'moment';

@Component({
  selector: 'app-create-graph',
  templateUrl: './create-graph.component.html',
  styleUrls: ['./create-graph.component.scss']
})
export class CreateGraphComponent implements OnInit, AfterViewInit {

  @Input() subjects: any[] = [];
  @Input() projectUsers: any[] = [];
  userID = JSON.parse(localStorage.getItem('currentUser'))['id'];
  userAdmin = false;
  @Input() allProjectUsers: any[] = [];
  @Input() projectLib: string = "Project";
  @Input() project: any = "Project";
  @Input() levelShowed: number = 0;
  @Output() create = new EventEmitter<void>();
  @Output() emitProjectUpdate = new EventEmitter<void>();
  @Output() emitSubjectUpdate = new EventEmitter<void>();
  @Input() projectview = false;
  @Input() isAdmin = false;
  @Input() creator = null;
  @Input() idProjet = null;
  @Input() isPrivate = false;
  @Input() contacts: any[] = [];
  otherContacts: any[] = [];
  projectLibelle = "Project";
  projectUsersCopy: any[] = [];
  subjectsPerPage = 8;
  currentPage = 0;
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  ongletId = this.messageService.getOngletId();
  selectedUsers = [];
  addingMembers = [];
  userStatus = null;

  mailInputShow = 0;
  mailProjInputShow = 0;
  contactemail = '';
  inputemail = '';
  inputprojemail = '';
  addcontactshow = 0;
  emailPattern: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  externalEmails: string[] = [];

  /*positions = [
    { top: '10%', left: '50%' },     // top
    { top: '10%', left: '90%' }, // top-right
    { top: '50%', left: '90%' },   // right
    { top: '90%', left: '90%' }, // bottom-right
    { top: '90%', left: '50%' },    // bottom
    { top: '90%', left: '10%' },      // bottom-left
    { top: '50%', left: '10%' },                // left
    { top: '10%', left: '10%' },                  // top-left
  ];
  
  positions = [               // left
    { top: '0%', left: '0%' },
    { top: '0%', left: '37%' },     // top
    { top: '0%', left: '74%' }, // top-right
    { top: '25%', left: '74%' },   // right
    { top: '50%', left: '74%' }, // bottom-right
    { top: '75%', left: '74%' }, // bottom-right
    { top: '75%', left: '37%' },    // bottom
    { top: '75%', left: '0%' },      // bottom-left
    { top: '50%', left: '0%' },               // top-left
    { top: '25%', left: '0%' }                  // top-left
  ];
  */
  positions = [               // left
    { top: '0%', left: '0%' },
    { top: '0%', left: '35%' },     // top
    { top: '0%', left: '70%' }, // top-right
    { top: '36%', left: '70%' },   // right
    { top: '72%', left: '70%' }, // bottom-right
    { top: '72%', left: '35%' },    // bottom
    { top: '72%', left: '0%' },      // bottom-left
    { top: '36%', left: '0%' }                  // top-left
  ];
  @ViewChild('parentiv', {static: false}) parentiv!: ElementRef<any>;
  //centerX = 165; // centre du svg (ex: 300px wrapper)
  //centerY = 165;
  centerX = 155; // centre du svg (ex: 300px wrapper)
  centerY = 140.0;
  centerY2 = 240.0;
  divwidth = 360;
  divheight = 360;
  dimensionloaded = false;
  tagRenameShow = false;
  projRenameShow = false;
  selectedTag : any;
  selectedProject : any;
  objectfiProject = null;
  libelleProject = null;
  deadlineProject = null;
  deadlineSubject = null;
  libelleSubject = null;
  mode = 1;
  activeConfirmIndex: number | null = null;
  searchContact: any;
  searchTagContact: any;
  indexUpd = 0;
  currentUserInfo: any;
  editingIndex: number | null = null;
  editedLabel = '';
  oldLabel = '';
  editingProject: boolean = false;
  editedLabelProject = '';
  oldLabelProject = '';
  @Output() projectRenamed = new EventEmitter<string>();
  public minDate = new Date();
  vibrantColors = [
    "#e7e0ff", 
    "#caf1ee", 
    "#fff0d3", 
    "#fbd8dc", 
    "#d8fdd2", 
    "#f4ded1", 
    "#d1e8ff", 
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', 
    '#caf1ee': '#008476', 
    '#fff0d3': '#9d6b2b', 
    '#fbd8dc': '#cd0635', 
    '#d8fdd2': '#1c8555', 
    '#f4ded1': '#855436', 
    '#d1e8ff': '#0060d3', 
    '#cbf2ef': '#008379'  
  };

  constructor(private authService: AuthService, private socketService: SocketService, private messageService: MessageService, public dialog: MatDialog, private cdr: ChangeDetectorRef, @Optional() public dialogRef: MatDialogRef<CreateGraphComponent>){
    var currentUserData = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUserInfo = currentUserData.givenName + currentUserData.familyName;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.recalculateDimensions();
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  getBgColor() {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    console.log("color one : "+this.vibrantColors[randomIndex])
    return this.vibrantColors[randomIndex];
  }

  getUserBgColor() {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    console.log("color one : "+this.vibrantColors[randomIndex])
    return this.vibrantColors[randomIndex];
  }

  recalculateDimensions() {
    console.log("welcome resize")
    if (!this.parentiv) return;
    const width = this.parentiv.nativeElement.offsetWidth;
    const height = this.parentiv.nativeElement.offsetHeight;
    this.divwidth = width;
    this.divheight = height;
    this.dimensionloaded = true;
    this.centerX = width / 2;
    this.centerY = height / 2;
    //this.centerY2 = (height / 3) * 2;
    //this.centerY = (height / 100) * 37;
    //this.centerY2 = (height / 100) * 61;
  }

  

  editSubject(tag, index: number) {
    this.editingIndex = index;
    this.oldLabel = tag.libelle;
    this.editedLabel = this.oldLabel;
  }

  confirmEdit(i: number){
    this.authService.changeSubjectName(this.editedLabel, this.paginatedSubjects[i].id).subscribe((res)=>{
      //this.projectTags[this.indexUpd].libelle = this.updateSubject;
      this.subjects[i].libelle = this.editedLabel;
      this.authService.subjectListUpd.emit(res);
      this.authService.obSubRename.next(res);
      this.editingIndex = null;
    },
      (error) => {
        err=>console.log(err)
      }
    );
    return;
  }

  cancelEdit() {
    this.editingIndex = null;
    this.editingProject = false;
  }

  editProject() {
    this.editingProject = true;
    this.oldLabelProject = this.projectLibelle;
    this.editedLabelProject = this.oldLabelProject;
  }

  confirmEditProject(){
    this.authService.changeProjetName(this.editedLabelProject, this.idProjet).subscribe(
      res => {
        this.projRenameShow = false;
        this.editingIndex = null;
        this.editingProject = false;
        this.projectLibelle = this.editedLabelProject;
        this.projectRenamed.emit(this.editedLabelProject);
        this.socketService.sendInstant({
              id: "",
              action: this.idProjet, // ID du projet
              type: "RENAMEPROJECT",
              author: this.currentUser, // peu importe 
              recipient: "", // peu importe 
              text: "",
              copy: "",
              private: false,
              res: res["libelle"], // le nouveau nom
              date: ""
        });
        //this.authService.obRefreshProjet.next();
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );
  }

  cancelEditProject() {
    this.editingIndex = null;
    this.editingProject = false;
  }


  ngAfterViewInit() {
    console.log("welcooome")
    // Assure-toi que la div est bien rendue avant d'accéder à sa largeur
    const width = this.parentiv.nativeElement.offsetWidth;
    const height = this.parentiv.nativeElement.offsetHeight;
    this.divwidth = width;
    this.divheight = height;
    this.dimensionloaded = true;
    this.centerX = width / 2;
    //this.centerY = height / 3;
    //this.centerY2 = (height / 100) * 2;
    this.centerY = (height / 100) * 37;
    this.centerY2 = (height / 100) * 61;
    this.recalculateDimensions();
    console.log('subjects:', this.subjects.length);
    this.projectUsers.forEach(item => {
      item.color = (item.user) ? (item.user.color) : item.color;
    });
    this.allProjectUsers.forEach(item => {
      item.color = (item.user) ? (item.user.color) : item.color;
    });
    this.subjects.forEach(element => {
    console.log('subjects:', element.userTag.length);
      element.userTag.forEach(item => {
          item.color = (item.user) ? (item.user.color) : item.color;
      });
    });
  }

  ngOnChanges() {
    /*if (this.contacts && this.projectUsersCopy) {
      this.filterOtherContacts();
    }*/
  }

  private filterOtherContacts() {
    const projectUserIds = this.projectUsersCopy.map(u => u.id);

    this.otherContacts = this.contacts.filter(
      contact => !projectUserIds.includes(contact.id)
    );
  }

  getFormattedName(member: { givenName: string; familyName: string }): string {
    var firstInitial = "";
    if(member.familyName) firstInitial = member.familyName.charAt(0).toUpperCase();
    return `${member.givenName} .${firstInitial}`;
  }

  isUserInTag(contact: any): boolean {
    if (!this.selectedTag || !this.selectedTag.userTag) return false;
    return this.selectedTag.userTag.findIndex(member => member.user.id === contact.id) !== -1;
  }

  addMemberToProject() {
    this.projectUsersCopy = [];
    
    var userData = JSON.parse(localStorage.getItem('currentUser'));
    this.projectUsersCopy = this.allProjectUsers.map(item => item.user);
    this.projectUsersCopy.unshift(userData);
    this.mode = 4;
  }

  fctCheckMemberProject(){}

  getbackGroundColor(){
    return "#57b031";
  }

  fctAdMember(userInfo){
    this.authService.addUserProject("/api/projects/"+this.idProjet, userInfo.id, null).subscribe(res => {
       if(res){
        var newUser = res;
        this.userStatus[res['user']['id']] = res['status'];
        this.projectUsers.push(newUser);
        this.allProjectUsers.push(newUser);
        this.projectUsersCopy.push(res['user']);
        this.searchContact = "";
        this.searchTagContact = "";
        var currentusername = JSON.parse(localStorage.getItem('currentUser'))['givenName'] +" "+ JSON.parse(localStorage.getItem('currentUser'))['familyName'];
        //this.authService.obRefreshProjet.next();
        this.socketService.sendInstant({
          id: "0",
          action: "0",
          type: "INVITATION",
          author: this.currentUser.id,
          recipient: currentusername,
          text: res['user']['id'],
          copy: "",
          private: false,
          res: res,
          project_lib: this.projectLib,
          date: res['dateCreated']
        });
       }
    },
    (error) => {
      if(error.error && error.error.violations){
        alert(error.error.violations[0].message);
      }
      else
      {
        alert(error.statusText);
      }

    });

  }

  addMemberToTag() {
    this.mode = 5;
  }

  fctCheckMemberTag(userInfo) {
      if (this.selectedTag.users && !this.selectedTag.users.some(user => user.id === userInfo.id)) {
        this.fctAdMemberTag(userInfo);
      } else {
        this.fctRemoveUserTag(userInfo);
      }
  }

  fctAdMemberTag(userInfo) {
      if (!this.selectedTag.users) {
        this.selectedTag.users = [];
      }
      this.selectedTag.users.push(userInfo);
      this.searchContact = "";
      this.searchTagContact = "";
  }

  fctRemoveUserTag(userInfo) {
      const index = this.selectedUsers.indexOf(userInfo.id);
      if (index > -1) {
        this.addingMembers.splice(index, 1);
        this.selectedUsers.splice(index, 1); // déjà sélectionné → on retire
      }
  }

  removeMember(member: any) {
    alert("id : "+member.id+"index : "+member.user.email)
    this.authService.deleteUserTag(member.id).subscribe(res => {
      const index = this.selectedTag.userTag.findIndex(item => item.id === member.id);
      if (index !== -1) {
          this.selectedTag.userTag.splice(index, 1)[0];
      }
    });
  }

  updCheckUserTag(contact){
      const index = this.selectedUsers.indexOf(contact.id);
      if (index > -1) {
        this.addingMembers.splice(index, 1);
        this.selectedUsers.splice(index, 1); // déjà sélectionné → on retire
      } else {
        this.addingMembers.push(contact);
        this.selectedUsers.push(contact.id); // pas encore sélectionné → on ajoute
      }
  }

  openInvitations(){
    this.mailInputShow = 1;
    this.inputemail = '';
    this.contactemail = '';
  }

  openProjInvitations(){
    this.mailProjInputShow = 1;
    this.inputprojemail = '';
    this.contactemail = '';
  }

  addExternalProjEmail(){
    console.log("addExternalProjEmail");
  }

  hideProjMailInput(){
    this.mailProjInputShow = 0;
    this.inputprojemail = '';
    this.contactemail = '';
  }

  isEmailValid(email: string): boolean {
      const regex = new RegExp(this.emailPattern);
      return regex.test(email);
  }

  hideMailInput(){
    this.mailInputShow = 0;
    this.inputemail = '';
    this.contactemail = '';
  }

  addExternalEmail() {
    if (!this.inputemail) return;
    const email = this.inputemail.trim().toLowerCase();
    if (email && !this.externalEmails.includes(email)) {
      this.externalEmails.push(email);
    }
    this.inputemail = '';
    this.hideMailInput();
  }

  removeExternalEmail(index: number) {
    this.externalEmails.splice(index, 1);
  }

  confirmUpdate(){
    const data = {
      libelle: this.selectedTag.libelle,
      users: this.selectedUsers,
      externalEmails: this.externalEmails
    };
    this.authService.updateTagDetails(this.selectedTag.id, data).then((res)=>{
      //this.projectTags[this.indexUpd].libelle = this.updateSubject;
      this.subjects[this.indexUpd] = res;
      this.authService.subjectListUpd.emit(res);
      this.authService.obSubRename.next(res);
      this.tagRenameShow = false;
      this.reloadUsers();
      this.mode = 2;
      this.selectedTag = res;
      //this.backToList();
      //this.dialogRef.close();
    }).catch(err=>console.log(err))
    return;
  }

  reloadUsers(){
    this.authService.getOneProject(this.idProjet)
      .subscribe(res => {
        var tmpArrayUser = res['userProject'];
        this.projectUsers = [];
        this.projectUsersCopy=[];
        var users = tmpArrayUser.filter(a => a.user != null);
        users.sort((a, b) => {
          if (a.user.fullName.toLowerCase() < b.user.fullName.toLowerCase()){
            return -1;
          }
          if (a.user.fullName.toLowerCase() > b.user.fullName.toLowerCase() ){
            return 1;
          }
          return 0;
        });
        
        this.projectUsers = users.sort((a, b) => {
          // Admins en premier
          if (a.isCreator) return -1;
          if (b.isCreator) return 1;
        
          // Co-admins ensuite
          if (a.isAdmin && !a.isCreator) return -1;
          if (b.isAdmin && !b.isCreator) return 1;
        
          // Les autres membres à la fin
          return 0;
        });
        var invited = tmpArrayUser.filter(a => a.user == null);
        invited.sort((a, b) => {
          if (a.email < b.email){
            return -1;
          }
          if (a.email > b.email ){
            return 1;
          }
          return 0;
        });
        for (var i = 0; i < invited.length; i++) {
              this.projectUsers.push(invited[i]);
        }
        for (var i = 0; i < this.projectUsers.length; i++) {
          if((this.projectUsers[i].isAdmin == true) && (this.projectUsers[i].user.id == this.userID))
          {
            this.userAdmin = true;
          }
        }
        this.projectUsers.forEach(item => {
          item.color = (item.user) ? (item.user.color) : item.color;        });
        //*************************** */
        this.projectUsersCopy= [...this.projectUsers];
        this.allProjectUsers = [...this.projectUsers];
        let userStatus = [];
        for (let index = 0; index < this.allProjectUsers.length; index++) {
              if(this.allProjectUsers[index]['user']){
                userStatus[this.allProjectUsers[index]['user']['id']] = this.allProjectUsers[index]['status'];
              }
        }
        this.userStatus = userStatus;
         
      });
  }

  confirmUpdateProject(){

    if (this.projectLibelle.trim().length == 0 ){
      return;
    }

     // Creation du projet
    this.authService.changeProjetName(this.projectLibelle, this.idProjet).subscribe(
      res => {
        this.projRenameShow = false;
        this.socketService.sendInstant({
              id: "",
              action: this.idProjet, // ID du projet
              type: "RENAMEPROJECT",
              author: this.currentUser, // peu importe 
              recipient: "", // peu importe 
              text: "",
              copy: "",
              private: false,
              res: res["libelle"], // le nouveau nom
              date: ""
        });
        //this.authService.obRefreshProjet.next();
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );

  }

  updateProjectDetails(){
    if (this.libelleProject.trim().length == 0 ){
      return;
    }

     // Creation du projet
    this.authService.updateProj(this.idProjet, this.libelleProject, this.deadlineProject, this.objectfiProject).subscribe(
      res => {
        this.projRenameShow = false;
        this.emitProjectUpdate.emit();
        this.socketService.sendInstant({
              id: "",
              action: this.idProjet, // ID du projet
              type: "RENAMEPROJECT",
              author: this.currentUser, // peu importe 
              recipient: "", // peu importe 
              text: "",
              copy: "",
              private: false,
              res: res["libelle"], // le nouveau nom
              date: ""
        });
        if (this.dialogRef) {
          this.dialogRef.removePanelClass('dialogmappingadd-container');
          this.dialogRef.addPanelClass('dialogmapping-container');
        }
        this.projectLibelle = this.libelleProject;
        this.project.libelle = this.libelleProject;
        this.project.deadline = this.deadlineProject;
        this.project.objectif = this.objectfiProject;
        this.mode = 1;
        //this.authService.obRefreshProjet.next();
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );

  }


  updateSubjectDetails(){
    if (this.libelleSubject.trim().length == 0 ){
      return;
    }

     // Creation du projet
    this.authService.updateSub(this.selectedTag.id, this.libelleSubject, this.deadlineSubject).subscribe(
      res => {
        if (this.dialogRef) {
          this.dialogRef.removePanelClass('dialogmappingadd-container');
          this.dialogRef.addPanelClass('dialogmapping-container');
        }
        this.subjects.find(m => m.id == this.selectedTag.id).libelle = this.libelleSubject;
        this.subjects.find(m => m.id == this.selectedTag.id).deadline = this.deadlineSubject;
        this.emitProjectUpdate.emit();
        this.mode = 1;
        //this.authService.obRefreshProjet.next();
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );

  }


  toggleDeleteConfirm(subject: any, index: number) {
    // Active ou désactive la popup pour ce bouton
    this.activeConfirmIndex = this.activeConfirmIndex === index ? null : index;
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
               data: { 
                 message: 'Voulez vous vraiment suppprimer le canal '+subject.libelle+'?',
                 title: 'Confirmation'
               },
               panelClass: 'confirmclass',
               backdropClass: 'custom-backdrop'
             });
         
             dialogRef.afterClosed().subscribe(result => {
               if (result) {
                this.confirmRemove(this.paginatedSubjects[index], index);
               } else {
                 this.cancelConfirm();
               }
    });
  }

  cancelConfirm() {
    this.activeConfirmIndex = null;
  }

  confirmRemove(tag: any, index: number) {
    this.subjects = this.subjects.filter(m => m.id !== tag.id);
    this.activeConfirmIndex = null;

    // Optionnel : message
    alert("Le canal a été supprimé.");
  }

  removeTag(tag){
    if(confirm("Voulez vraiment suppprimer le canal "+tag.libelle)) {
      this.subjects = this.subjects.filter(m => m.id !== tag.id);
      alert("Le canal est supprimé.")
    }
  }

  onNoClick(){
    if (this.dialogRef) {
      this.dialogRef.removePanelClass('dialogmappingadd-container');
      this.dialogRef.addPanelClass('dialogmapping-container');
    }
    this.emitProjectUpdate.emit();
    this.mode = 1;
    this.selectedProject = null;
    this.selectedTag = null;
  }

  updateTag(tag, i){
    if (this.dialogRef) {
      this.dialogRef.removePanelClass('dialogmapping-container');
      this.dialogRef.addPanelClass('dialogmappingadd-container');
    }
    this.selectedTag = tag;
    this.deadlineSubject = this.selectedTag.deadline;
    this.libelleSubject = this.selectedTag.libelle;
    console.log("taaa 0 : "+tag.libelle)
    console.log("taaa 0 : "+tag.deadline)
    this.tagRenameShow = false;
    this.indexUpd = i;
    this.mode = 2;
    this.emitSubjectUpdate.emit();
    this.selectedUsers = [];
    this.addingMembers = [];
    for (let index = 0; index < tag.userTag.length; index++) {
          if(tag.userTag[index]['user'] && tag.userTag[index]['user']['id'] != this.currentUser){
            this.selectedUsers.push(tag.userTag[index]['user']['id']);
            this.addingMembers.push(tag.userTag[index]['user']);
          }

    }
  }

  changeTagStatus(tag, i, status){
    var project_status = 'INPROGRESS';
    this.authService.changeSubjectStatus(tag.id, status).subscribe((res)=>{
      this.paginatedSubjects[this.indexUpd] = res;
      this.subjects.find(m => m.id == tag.id).status = status;
      this.subjects.find(m => m.id == tag.id).validatedAt = res["validatedAt"];
      if (!this.subjects.some(s => s.status === 'INPROGRESS')) {
        project_status = 'FINISHED';
        this.changeProjectStatus('FINISHED');
      } else this.changeProjectStatus('INPROGRESS');
    });
  }

  changeProjectStatus(status){
    this.authService.changeProjectStatus(this.project.id, status).subscribe((res)=>{
      this.project.status = status;
      console.log("status : "+this.project.status)
    });
  }

  goBack(): void {
    switch (this.mode) {
      case 5:
        this.mode = 2;
        break;
      case 4:
        this.mode = 3;
        break;
      case 2:
        if (this.dialogRef) {
          this.dialogRef.removePanelClass('dialogmappingadd-container');
          this.dialogRef.addPanelClass('dialogmapping-container');
        }
        this.mode = 1;
        break;
      case 3:
        if (this.dialogRef) {
          this.dialogRef.removePanelClass('dialogmappingadd-container');
          this.dialogRef.addPanelClass('dialogmapping-container');
        }
        this.mode = 1;
        break;
      default:
        // Tu peux notifier le parent si tu veux qu'on quitte complètement
        break;
    }
  }


  updateProject(){
    if (this.dialogRef) {
      this.dialogRef.removePanelClass('dialogmapping-container');
      this.dialogRef.addPanelClass('dialogmappingadd-container');
    }
    this.selectedTag = null;
    this.selectedProject = this.project;
    this.deadlineProject = this.selectedProject.deadline;
    this.libelleProject = this.selectedProject.libelle;
    this.objectfiProject = this.selectedProject.objectif;
    console.log("project : "+JSON.stringify(this.selectedProject))
    this.tagRenameShow = false;
    this.projRenameShow = false;
    this.mode = 3;
    //this.emitProjectUpdate.emit();
    this.emitSubjectUpdate.emit();
  }
  
  onDateSelectedSub(event: any): void {
    const selectedDate = event.value;
    if (selectedDate) {
        this.selectedTag.deadline = moment(selectedDate).format('DD-MM-YYYY').toLocaleString();
    }
  }
  
  onDateSelectedProj(event: any): void {
    const selectedDate = event.value;
    if (selectedDate) {
        this.selectedProject.deadline = moment(selectedDate).format('DD-MM-YYYY').toLocaleString();
    }
  }

  renameProject(){
    this.projRenameShow = true;
  }

  renameTag(){
    this.tagRenameShow = true;
  }

  get paginatedSubjects() {
    const start = this.currentPage * this.subjectsPerPage;
    return this.subjects.slice(start, start + this.subjectsPerPage);
  }

  get canGoNext(): boolean {
    return (this.currentPage + 1) * this.subjectsPerPage < this.subjects.length;
  }

  get canGoPrevious(): boolean {
    return this.currentPage > 0;
  }

  nextPage() {
    if (this.canGoNext) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.canGoPrevious) {
      this.currentPage--;
    }
  }

  
  getPositionPx(percent: string): number {
    //console.log("divwidth :"+this.divwidth)
    //const percentValue = parseFloat(percent);
    const percentValue = (parseFloat(percent) + 15);
    //return (percentValue / 100) * 330; // wrapper width/height = 300
    return (percentValue / 100) * this.divwidth; // wrapper width/height = 300
  }

  getPositionPxTop(percent: string): number {
    //console.log("divheight :"+this.divheight)
    //const percentValue = parseFloat(percent);
    const percentValue = (parseFloat(percent) + parseFloat('14%'));
    //return (percentValue / 100) * 330; // wrapper width/height = 300
    return (percentValue / 100) * this.divheight; // wrapper width/height = 300
  }


  // Détermine l'emplacement du prochain bouton "+"
  getNextSlotIndex(): number {
    if (this.subjects.length === 0) return 4; // premier canal -> mid-center
    if (this.subjects.length === 1) return 1; // deuxième canal -> top-center
    return -1; // pas d'emplacement prévu au-delà
  }

  getImageFromStatus(status){
    if(status === 'INPROGRESS') return '../../../../assets/img/inprogress.png';
    else if(status === 'CANCELLED') return '../../../../assets/img/cancelled.png';
    else return '../../../../assets/img/finished.png';
  }

  ngOnInit() {
    this.mode = 1;
    var userData = JSON.parse(localStorage.getItem('currentUser'));
    this.projectLibelle = this.projectLib;
    this.projectUsersCopy= [...this.projectUsers];
    this.projectUsersCopy.unshift(userData);
    this.filterOtherContacts();
    let userStatus = [];
    for (let index = 0; index < this.allProjectUsers.length; index++) {
          if(this.allProjectUsers[index]['user']){
            userStatus[this.allProjectUsers[index]['user']['id']] = this.allProjectUsers[index]['status'];
          }

    }
    this.userStatus = userStatus;
  }

  scrollRight(container: HTMLElement) {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  }

  scrollLeft(container: HTMLElement) {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  }
  
  getAvatarlUrl(avatarLink){
      return environment.server_url+avatarLink;
  }

  getInitials(libelle: string): string {
    if(!libelle) return;
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  /*
  @ViewChild('graphContainer', { static: true }) graphContainer!: ElementRef;

  ngOnChanges() {
    this.drawGraph();
  }

  drawGraph() {
    const width = 400;
    const height = 400;
    const radius = 120;
    const svg = d3.select(this.graphContainer.nativeElement)
      .html('')
      .append('svg')
      .attr('width', width)
      .attr('height', height);

    const centerX = width / 2;
    const centerY = height / 2;

    // Cercle central
    svg.append('circle')
      .attr('cx', centerX)
      .attr('cy', centerY)
      .attr('r', 40)
      .attr('fill', '#4CAF50');

    // Nom du projet
    svg.append('text')
      .attr('x', centerX)
      .attr('y', centerY + 5)
      .attr('text-anchor', 'middle')
      .attr('fill', 'white')
      .style('font-size', '14px')
      .text(this.projectName);

    const angleStep = 2 * Math.PI / Math.max(this.topics.length, 1);

    this.topics.forEach((topic, index) => {
      const angle = index * angleStep;
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);

      svg.append('line')
        .attr('x1', centerX)
        .attr('y1', centerY)
        .attr('x2', x)
        .attr('y2', y)
        .attr('stroke', '#888');
      
      svg.append('circle')
        .attr('cx', x)
        .attr('cy', y)
        .attr('r', 20)
        .attr('fill', '#2196F3');

      // Nom du sous-groupe
      svg.append('text')
        .attr('x', x)
        .attr('y', y + 5)
        .attr('text-anchor', 'middle')
        .attr('fill', 'white')
        .style('font-size', '12px')
        .text(topic);
    });
  }*/
 center = 150;
  radius = 100;
  diameter = this.center * 2;

  selectedMembers: string[] = [];
  selectedSubject: string | null = null;

  /*
  subjects = [
    { name: 'Naissance', members: ['Alice', 'Bob'] },
    { name: 'Mariage', members: ['Claire'] },
    { name: 'Décès', members: ['Daniel'] }
  ];

  selectedMembers: string[] = [];
  selectedSubject: string | null = null;

  getX(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.cos(angle);
  }

  getY(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.sin(angle);
  }

  addSubject() {
    const newName = prompt('Nom du nouvel service ?');
    if (newName) {
      this.subjects.push({ name: newName, members: [] });
    }
  }*/

  getX(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.cos(angle);
  }

  getY(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.sin(angle);
  }

  emitCreate() {
    this.create.emit(); // ← déclenche l’événement vers le parent
  }
  
  getSubject(subject){
    if(subject === "Thématique d'échange"){
      return "Thématique";
      } else return subject;
  }

  showMembers(index: number) {
    this.selectedSubject = this.subjects[index].name || this.subjects[index].title || 'Service';
    this.selectedMembers = this.subjects[index].userTag || [];
  }

  countMembers(index: number) {
    return this.subjects[index].userTag.length || 0;
  }

  showProjectMembers(index: number) {
  }

  countProjectMembers() {
    //return this.projectUsersCopy.length;
    return this.allProjectUsers.length;
  }

  updateListUser(contact,values){
    this.authService.updateUserProject(contact, values)
    .subscribe(res => {
      for (var i = 0; i < this.allProjectUsers.length; i++) {
        if(res['id'] ===  this.allProjectUsers[i]['id'])
          this.allProjectUsers[i] = res;
      }
      //this.authService.obRefreshProjet.next();
    });
  }

  updateUserProject(contact, key){
      let values = null;
      switch (key) {
        case 1:
          values = {isAdmin: false};
          this.updateListUser(contact, values);
          this.socketService.sendInstant({
            id: "",
            action: this.idProjet,
            type: "DELETEADMIN",
            author: this.currentUser.id,
            recipient: this.currentUserInfo,
            text: "",
            copy: "",
            private: false,
            res: contact.user.id,
            date: ""
          });
          break;
        case 2:
          values = {isMember: false};
          this.updateListUser(contact, values);
          break;
        case 3:
          values = {isAdmin: true};
          this.updateListUser(contact, values);
          this.socketService.sendInstant({
            id: "",
            action: this.idProjet,
            type: "MARKADMIN",
            author: this.currentUser.id,
            recipient: this.currentUserInfo,
            text: "",
            copy: "",
            private: false,
            res: contact.user.id,
            date: ""
          });
          break;
        case 5:
          values = {isMember: true};
          this.updateListUser(contact, values);
          break;
        case 4:
          const fullname = contact.user ? contact.user.fullName : contact.email;
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '350px',
            data: "Vous êtes sur le point de retirer "+fullname+" du projet ?"
          });
          dialogRef.afterClosed().subscribe(result => {
            if(result) {
              this.authService.deleteUserProject(contact)
              .subscribe(res => {
                for (var i = 0; i < this.allProjectUsers.length; i++) {
                  if(contact['id'] ===  this.allProjectUsers[i]['id'])
                    this.allProjectUsers.splice(i, 1); 
                }
                delete this.userStatus[contact.user.id];
                this.cdr.detectChanges();
                for (let s = 0; s < this.subjects.length; s++) {
                  if (this.subjects[s].userTag) {
                    this.subjects[s].userTag = this.subjects[s].userTag.filter(
                      ut => !(ut.user && ut.user.id === contact.user.id)
                    );
                  }
                }
                //this.authService.obRefreshProjet.next();
              });
            }
          });
          break;
        default:
          break;
      }
    }

  generateGradientDots(x1: number, y1: number, x2: number, y2: number, spacing: number): { x: number, y: number, opacity: number }[] {
    const points = [];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const steps = Math.floor(distance / spacing);

    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      //const opacity = 0.1 + t * 0.8; // de 0.2 à 1
      const opacity = 1; // de 0.2 à 1
      points.push({
        x: x1 + dx * t,
        y: y1 + dy * t,
        opacity: opacity
      });
    }

    return points;
  }

  generateInterGradientDots(x1: number, y1: number, x2: number, y2: number, spacing: number): { x: number, y: number, opacity: number }[] {
    const points = [];
    const dx = x2 - x1;
    const dy = y2 - y1;
    console.log("y2 : "+y2)
    console.log("y1 : "+y1)
    console.log("x2 : "+x2)
    console.log("x1 : "+x1)
    const distance = Math.sqrt(dx * dx + dy * dy);
    const steps = Math.floor(distance / spacing);

    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      //const opacity = 0.1 + t * 0.8; // de 0.2 à 1
      const opacity = 1; // de 0.2 à 1
      points.push({
        x: x1 + dx * t,
        y: y1 + dy * t,
        opacity: opacity
      });
    }

    return points;
  }


}

